import { registerModule } from '@/app/app.store'
import Common from '../common.vue'

export default {
  
  path: '/promotion',
  component: Common,
  children: [
    {
      name: 'panicbuy',
      path: 'panic-buy',
      component: () => import('./panic-buy.vue'),
      beforeEnter: (to: any, from: any, next: () => void) => {
        import('./promotion-service').then(({ PANIC_BUY_STORE }) => {
          if (PANIC_BUY_STORE) registerModule(to, PANIC_BUY_STORE)
          next()
        })
      }
    },
    {
      name: 'choice',
      path: 'choice',
      component: () => import('./choice.vue'),
      beforeEnter: (to: any, from: any, next: () => void) => {
        import('./promotion-service').then(({ CHOICE_STORE }) => {
          if (CHOICE_STORE) registerModule(to, CHOICE_STORE)
          next()
        })
      }
    }
  ]
}
